"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodMethodEnum = void 0;
var PaymentMethodMethodEnum;
(function (PaymentMethodMethodEnum) {
    PaymentMethodMethodEnum["PICKUP"] = "pickup";
    PaymentMethodMethodEnum["DELIVERY"] = "delivery";
    PaymentMethodMethodEnum["CUSTOM"] = "custom";
})(PaymentMethodMethodEnum = exports.PaymentMethodMethodEnum || (exports.PaymentMethodMethodEnum = {}));
